import { Row } from 'react-bootstrap';
import styled from 'styled-components'
import { colors } from '../../../theme/theme';

export const Container = styled.div``;

export const Main = styled.main`
    background: ${colors.greyscale.white};
    border-radius: 5px;
    padding: 20px;
    /* padding-bottom: 15px; */
    border-left: 10px solid ${colors.mainColors.capri};
    max-height: 120px;
    overflow-y: hidden;
    transition: 0.5s ease-out;

    h2 { 
        font-size: 16px;
        font-weight: 700;
        color: #000;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 400px;
        
    }

    em { 
        font-size: 20px;
        color: ${colors.mainColors.capri};
    }
    
    span { 
        font-size: 14px;
        color: ${colors.mainColors.capri};
    }

    h5 { 
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 400px;
    }

    p { 
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 500px;
        color: ${colors.greyscale.darker_grey}
    }

    &:hover { 
        max-height: 300px !important;
        transition: 1s ease-out;
        
    }

    
    @media only screen and (max-width: 1000px) { 
        max-height: 1000px !important;
    }


    .utilsButtons { 
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        justify-content: center;
        align-items: center;

        @media only screen and (max-width: 1000px) { 
        flex-direction: row;
        }
    }
    

`;


export const DetailsButton = styled.button`
    color: ${colors.greyscale.dark_grey};
    background-color: transparent;
    padding: 1;
    border-radius: 50;
    border: 0;
    transition: 1s ease-out;


    &:hover { 
        color: ${colors.greyscale.darker_grey};
        border-radius: 50;
        transition: 1s ease-out;
        
    }
`;

export const HiddenRow = styled(Row)`

`

export const Details = styled.div`
    background: ${colors.greyscale.white};
    padding: 20px;
    border-radius: 5px;
    color: ${colors.greyscale.darker_grey};

    p { 
        font-size: 14px;
    }

    b { 
        color: ${colors.greyscale.black}
    }
`;